<template>
  <div class="bbm-page">
    <div class="bbm-page__container">
      <span class="bbm-page__label">Insights</span>
      <h1 class="bbm-page__title">Brussels Ecosystem Intelligence</h1>
      <p class="bbm-page__body">Stay up to date with the latest news, reports, and trends from the Brussels business ecosystem.</p>
    </div>
    <SimplifiedFooterBrussels />
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import SimplifiedFooterBrussels from '@/components/SimplifiedFooter/SimplifiedFooterBrussels.vue'

  export default defineComponent({
    name: 'StaticHomeBrusselsInsights',
    components: { SimplifiedFooterBrussels },
  })
</script>

<style scoped lang="scss">
  $bbm-primary: var(--primary-community);
  $bbm-accent: #ff6f31;

  .bbm-page {
    font-family: 'Inter', sans-serif;
    min-height: 100vh;
    background: #f7f9fb;
  }

  .bbm-page__container {
    max-width: 1280px;
    margin: 0 auto;
    padding: 80px 32px;
  }

  .bbm-page__label {
    display: block;
    font-size: 0.75rem;
    font-weight: 700;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: $bbm-accent;
    margin-bottom: 12px;
  }

  .bbm-page__title {
    font-family: 'Space Grotesk', sans-serif;
    font-size: 2.5rem;
    font-weight: 700;
    color: $bbm-primary;
    margin: 0 0 24px;
  }

  .bbm-page__body {
    font-size: 1.125rem;
    line-height: 1.6;
    color: #43474f;
    max-width: 640px;
  }
</style>
